var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-frame"},[_c('iframe',{ref:"frameRef",staticClass:"frame-box",attrs:{"allow":"microphone *;camera *;midi *;encrypted-media *; display-capture *;","src":_vm.urlStr,"frameborder":"0","width":"100%","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }